<template>
<div class='permissions'>
  <table class='members-table'>
    <tr>
      <th>
        <!-- 添加成员下拉框 -->
        所有成员
      </th>
      <th style='text-align:center; width: 60%'>
        <el-row v-once>
          <el-col :span="6">管理账号</el-col>
          <el-col :span="6">查看成员</el-col>
          <el-col :span="6" v-once>{{$t('browseProject')}}</el-col>
          <el-col :span="6" v-once>{{$t('editProject')}}</el-col>
        </el-row>
      </th>
    </tr>
    <tr v-if="loading">
      <td class='loading-cell' colspan="10">
        <div class='spinner-wrapper'>
          <i class='ppj-icon-spinner' />
        </div>
      </td>
    </tr>
    <tr v-for="member in members" :key="member.id" v-else>
      <td class='profile' v-once>
        <div class='img avatar' :style="{backgroundImage: 'url('+member.user.profile_picture+')'}"></div>
        <div class='nickname'>{{member.user.nickname}}</div>
        <div class='email'>{{member.user.email}}</div>
      </td>
      <td style='text-align:center;'>
        <el-checkbox-group :value="member.permissions.split(',')" @input="setPermissions(member.id, $event)">
          <el-row>
            <el-col :span="6">
              <el-checkbox label='edit_members' :disabled="member.role === 'owner'">&nbsp;</el-checkbox>
            </el-col>
            <el-col :span="6">
              <el-checkbox label='view_members' :disabled="member.role === 'owner'">&nbsp;</el-checkbox>
            </el-col>
            <el-col :span="6">
              <el-checkbox label='view_projects' :disabled="member.role === 'owner'">&nbsp;</el-checkbox>
            </el-col>
            <el-col :span="6">
              <el-checkbox label='edit_projects' :disabled="member.role === 'owner'">&nbsp;</el-checkbox>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </td>
    </tr>
  </table>
  <el-pagination small layout="prev, pager, next" :total="totalItems" :page-count="totalPages" :current-page.sync="currentPage" :page-size="pageSize" @current-change="fetch">
  </el-pagination>
</div>
</template>

<i18n>
{
  "zh-cn": {
    "browseProject": "查看@:common.project",
    "editProject": "修改@:common.project"
  }
}
</i18n>

<style lang='scss' scoped>
.permissions {
    padding-top: $margin-base;

    .el-pagination {
        margin-top: $margin-base;
        text-align: center;
    }
}
</style>

<script>
import lodash from 'lodash'

export default {
  data() {
    return {
      members: [],
      currentPage: 1,
      totalPages: 1,
      pageSize: 1,
      totalItems: 1,
      loading: false
    }
  },
  methods: {
    setPermissions(memId, permissions) {
      let vm = this
      let index = lodash.findIndex(vm.members, {
        id: memId
      })
      let oldPermissions = vm.members[index].permissions
      let newPermissions = permissions.join(',')
      vm.$set(vm.members[index], 'permissions', newPermissions)

      // async
      vm.$store.dispatch('organization/editMember', {
        orgId: vm.organization.id,
        memId: memId,
        permissions: newPermissions
      }).then(_ => {}).catch(_ => {
        // might cannot be modified due to accessibility
        vm.$set(vm.members[index], 'permissions', oldPermissions)
      })
    },
    fetch() {
      let vm = this
      vm.loading = true
      vm.$store.dispatch('organization/members', {
        orgId: vm.organization.id,
        page: vm.currentPage || 1
      }).then(res => {
        vm.members = res.data.list
        vm.totalPages = res.data.total_pages
        vm.pageSize = res.data.page_size
        vm.totalItems = res.data.total_items
        vm.loading = false
      })
    }
  },
  mounted() {
    this.fetch()
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?34b7e05c